function Chips({title, isActive, onClick}) {
    return (
        <button className={`rounded-full px-4 py-1.5 text-sm shadow border border-gray-200 hover:border-gray-300 ${isActive ? "bg-primary-800 text-white" : "bg-white text-gray-600"}`} onClick={() => onClick()}>{title}</button>
    );
}

export default Chips;